<div class="modal-header text-center" style="color: white;background-color: #0d47a1">
  <h4 class="modal-title w-100">{{x_tipo}} de Aula Virtual</h4>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosemodal()">
    <span aria-hidden="true" class="white-text">&times;</span>
  </button>
</div>
<!--Body-->
<div class="modal-body">
  <mdb-card *ngIf="muestra_nota">
    <mdb-card-body>
        <div class="form-row mb-3">
            <div class="col-6">Lista de <b>{{listParticipantesAV.length}}</b> alumnos con notas mayores a :</div>
            <div class="col-2">
              <select class="browser-default custom-select" [(ngModel)]="nota_base" (change)="onNotaBaseChange()">
                <option *ngFor='let num of "0-1-2-3-4-5-6-7-8-9-10-11-12-13-14-15-16-17-18-19".split("-")' [value]="num">{{num}}</option>
              </select>
            </div>
        </div>
      </mdb-card-body>
  </mdb-card>
<mdb-card>
  <mdb-card-body>
    <div class="table-responsive">
      <table mdbTable hover="true" class="table">
          <thead>
            <tr>
              <th scope="col">Nro</th>
              <th scope="col">Nombres</th>
              <th scope="col" *ngIf="false">Email</th>
              <th scope="col" *ngIf="muestra_nota">Nota</th>
              <th scope="col">Agregar</th>
            </tr>
          </thead>

          <tbody>
            <tr mdbTableCol *ngFor="let listParti of listParticipantesAV | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize ;let i = index">
              <th>{{i + 1+10*(page-1)}}</th>
              <th>{{listParti.nombres}}</th>
              <td *ngIf="false">{{listParti.email}}</td>
              <td *ngIf="muestra_nota">{{listParti.dato}}</td>
              <th ><button *ngIf="listParti.id != 0" type="button" color="link" (click)="onAgregar(listParti)" class="btn-sm btn-sm-icon" mdbWavesEffect mdbBtn><mdb-icon fas icon="user-plus" size="2x" class="blue-text pr-3"></mdb-icon></button></th>
            </tr>
          </tbody>
        </table>
        </div>
          <div class="text-center">

            <ngb-pagination [maxSize]=3 [(page)]="page" class="d-flex justify-content-center"
              [pageSize]="pageSize" [boundaryLinks]="true" [collectionSize]="listParticipantesAV.length">
            </ngb-pagination>
          </div>
  </mdb-card-body>
</mdb-card>

    <br>
    <div class="justify-content-center" style="text-align: center;">
      <button mdbBtn type="button" (click)="onAgregarTodos()" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
          <mdb-icon fas icon="user-plus" class="mr-1"></mdb-icon>AGREGAR TODOS ({{listParticipantesAV.length}})</button>
    </div>
</div>
